<template>
  <div class="cust-eval-wrap">
    <header class="header">
      <p class="title">{{title}}</p>
      <p class="info">
        <span v-if="info&&info.length>0">
          <i class="el-icon-warning"></i>
          {{info}}
        </span>
      </p>
    </header>
    <el-alert :title="remainingEval" :closable="false" type="warning" show-icon></el-alert>
    <article class="art-wrap flex flex-middle">
      <table class="eval-content">
        <tr>
          <td class="td">
            <p class="padding">测评分数 :</p>
            <p class="result bold" :class="{warn:info}">{{score}}</p>
          </td>
          <td class="td">
            <p class="padding">测评日期 :</p>
            <p class="result bold" :class="{warn:info}">{{lvDate}}</p>
          </td>
        </tr>
        <tr>
          <td class="td">
            <p class="padding">风险等级 :</p>
            <p class="result bold" :class="{warn:info}">{{lv}}</p>
          </td>
          <td class="td">
            <p class="padding">测评有效期 :</p>
            <p class="result bold" :class="{warn:info}">{{lvExpDate}}</p>
          </td>
        </tr>
      </table>
    </article>
  </div>
</template>
<script>
export default {
  props: {
    title: "",
    lv: "",
    score: "",
    lvDate: "",
    lvExpDate: "",
    remainingEval: "",
    info: "",
  }
};
</script>
<style lang="less" scoped>
.cust-eval-wrap {
  .title {
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: #232323;
    line-height: 36px;
  }
  .art-wrap {
    flex-direction: column;
    .eval-content {
      display: flex;
      width: 600px;
      padding: 0;
      font-size: 25px;
      flex-direction: column;
      background: #f0f3f8;
      border: 2px solid rgba(206, 210, 225, 1);
      border-radius: 4px;
      margin-bottom: 60px;
      tr {
        display: flex;
        &:last-child {
          border-top: 1px solid #cacdd7;
        }
        td {
          display: flex;
          width: 300px;
          height: 106px;
          align-items: center;
          p {
            display: inline-block;
            width: 210px;
          }
          .padding {
            text-align: right;
            font-weight: 500;
            color: #6e767d;
          }
          .result {
            text-align: left;
            padding-left: 10px;
            color: #232323;
          }
        }
      }
    }
  }
  .el-alert {
    margin: 36px 0 16px;
    padding: 0;
    justify-content: center;
    background: none;
    .el-alert__icon {
      font-size: 18px;
      width: 18px;
    }
    .el-alert__title {
      font-size: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/message/src/content/custEvaluate.vue